import { MapContainer, Marker, TileLayer, useMapEvents, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { useEffect, useState } from "react";

const MapaActa2 = ({ setValue, clearErrors, latitud, longitud, sendForm, setSendForm, id }) => {
  const [position, setPosition] = useState(null);
  const [center, setCenter] = useState([-38.951252, -68.059187]);

  function LocationMarker() {
    const map = useMapEvents({
      click(e) {
        clearErrors(["latitud", "longitud"]);
        setPosition(e.latlng);
        map.flyTo(e.latlng, map.getZoom(), 13);
        setValue("latitud", e.latlng.lat);
        setValue("longitud", e.latlng.lng);
        setCenter([e.latlng.lat, e.latlng.lng]);
      },
    });
    return position === null ? null : <Marker position={position} />;
  }

  useEffect(() => {
    if (sendForm) {
      setPosition(null);
      setSendForm(false);
    }

    if (latitud) setPosition(null);
  }, [sendForm]);

  useEffect(() => {
    if (id) {
      setPosition(null);
      if (latitud && longitud) {
        setCenter([Number(latitud), Number(longitud)]);
      }
    }
  }, [id, latitud, longitud]);

  const GetPosicion = ({ position }) => {
    const map = useMap();
    useEffect(() => {
      if (position) {
        map.flyTo(position, map.getZoom(), 5);
      }
    }, [position, map]);
  };

  return (
    <>
      <MapContainer className="w-100 h-100" center={center} zoom={15} attributionControl={false}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <LocationMarker />
        {id && latitud && longitud && <Marker position={[latitud, longitud]} />}
        <GetPosicion position={center} />
      </MapContainer>
    </>
  );
};

export default MapaActa2;
